// extracted by mini-css-extract-plugin
export default {"root":"styles_root__RWOWO","disabled":"styles_disabled__xAOqh"};